import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the MojoAuth response from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const state = urlParams.get('state');
        const code = urlParams.get('code');

        if (code) {
          // Here you would typically verify the code with your backend
          // For demo purposes, we'll just proceed
          
          // Get the stored form data
          const formData = JSON.parse(localStorage.getItem('tempFormData'));
          if (formData) {
            // Store the verified form data
            localStorage.setItem('userFormData', JSON.stringify(formData));
            // Set form completion flag
            sessionStorage.setItem('formCompleted', 'true');
            // Clear temporary data
            localStorage.removeItem('tempFormData');
            // Navigate back to dashboard
            navigate('/dashboard');
          }
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/dashboard');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'Poppins, sans-serif'
    }}>
      Verifying your email...
    </div>
  );
};

export default AuthCallback; 